<template>
  <div class="content">
    <div class="content-2">
      <h3>Service Status</h3>
      <div class="md-layout cards top-cards">
        <div class="md-layout-item item">
          <p class="category">Total Services</p>
          <p class="title">{{ providers.length }}</p>
        </div>
        <div class="md-layout-item item">
          <p class="category">Active Services</p>
          <p class="title">{{ activeProvidersCount }}</p>
        </div>
        <div class="md-layout-item item">
          <p class="category">Average Reliability</p>
          <p class="title">{{ averageSuccess }}%</p>
        </div>
      </div>
      <div class="bottom-view">
        <div class="search-container">
          <input v-model="searchQuery" placeholder="Search services" />
          <md-icon>search</md-icon>
        </div>

        <div class="md-layout cards">
          <div v-for="(provider, index) in filteredProviders" :key="index">
            <div class="md-layout-item item">
              <div class="inner-item-middle-1">
                <img
                  :alt="provider.disco_code + ' Logo'"
                  :src="getImagePath(provider.disco_code)"
                  width="70px"
                  height="30px"
                />
                <div :class="['status-item', provider.provider_online ? 'on' : 'off']">
                  <p>{{ provider.provider_online ? "AVAILABLE"
                      : "PROVIDER MAINTENANCE IN PROGRESS" }}</p>
                </div>
              </div>
              <div class="inner-item-middle-1">
                <p>{{ provider.disco_code }} ({{ provider.vertical }})</p>
                <div class="inner-item-middle-1-right">
                  <HeartBeat class="icon" />
                  <p>Reliability:</p>
                  <p>{{  40 >= provider.success_percentage
                    || !provider.provider_online ? " " : provider.success_percentage+ " %"  }}</p>
                </div>
              </div>
              <div class="progress-container">
                <p :class="getStatusClass(provider.success_percentage, provider.provider_online)">
                  {{ getStatusLabel(provider.success_percentage, provider.provider_online) }}
                </p>
                <div
                  :class="[
                    'progress',
                    getStatusClass(provider.success_percentage, provider.provider_online),
                  ]"
                  :style="{ width: !provider.provider_online ? '0'
                    : provider.success_percentage + '%' }"
                ></div>
              </div>
              <div
                :class="[
                  'inner-item-bottom',
                  getStatusClass(provider.success_percentage, provider.provider_online),
                ]"
              >
                <div class="items-inner">
                  <md-icon class="icon">
                    {{ getStatusIcon(provider.success_percentage, provider.provider_online) }}
                  </md-icon>
                  <p>
                    {{
                      getStatusLabel(provider.success_percentage, provider.provider_online) ===
                      "Excellent"
                        ? "Functioning optimally"
                        : getStatusLabel(provider.success_percentage, provider.provider_online) ===
                          "Unstable"
                        ? "Performance issues detected"
                        : getStatusLabel(provider.success_percentage, provider.provider_online) ===
                          "Offline" ?
                          "PROVIDER MAINTENANCE IN PROGRESS"
                        : "Service disruption/downtime"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.content {
  padding: 0 90px;
}
.content-2 {
  display: flex;
  flex-direction: column;
  padding: 0 90px;
  width: 100%;
}
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* two max */
  gap: 24px;
  width: 100%;
}

/* optional: if you want *strictly* max 2 columns */
@media (min-width: 0px) {
  .cards {
    grid-template-columns: 1fr; /* mobile: 1 column */
  }
}

@media (min-width: 768px) {
  .cards {
    grid-template-columns: repeat(2, 1fr); /* tablet+ : 2 columns */
  }
}
.md-layout-item.item {
  background: #fff;
  flex: 1;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 0px 0px 0px #00000000;
  box-shadow: 0px 0px 0px 0px #00000000;
  box-shadow: 0px 1px 3px 0px #0000001a;
  box-shadow: 0px 1px 2px -1px #0000001a;
}
.bottom-view {
  margin-top: 52px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.search-container {
  height: 42px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding-right: 17px;
}
.search-container input {
  border: none;
  width: 100%;
  height: 100%;
  padding: 9px 17px;
}
.status-item {
  padding: 4px 10px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  height: 27px;
}
.status-item.on {
  background-color: #dcfce7;
  color: #166534;
}
.status-item.off {
  background-color: orange;
  color: #ffff;
}
.md-layout-item.item .inner-item-middle-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.inner-item-middle-1 > p,
.inner-item-middle-1-right > p:nth-child(2) {
  font-size: 14px;
  font-weight: 700;
  color: #000;
}
.inner-item-middle-1-right > p:nth-child(1) {
  font-size: 14px;
  font-weight: 400;
  color: #4b5563;
}
.md-layout-item.item .inner-item-middle-1-right {
  display: flex;
  align-items: center;
  gap: 7px;
}

.md-layout-item.item .inner-item-bottom {
  padding-top: 17px;
  border-top: 2px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  margin-top: 16px;
}
.md-layout-item.item .progress-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.md-layout-item.item .progress-container p {
  font-size: 10px;
  color: #166534;
  font-weight: 700;
}
.md-layout-item.item .progress-container .progress.good {
  height: 10px;
  width: 100%;
  border-radius: 9999px;
}
.progress {
  height: 10px;
  width: 100%;
  border-radius: 9999px;
}

.progress.good {
  background-color: #22c55e;
}

.progress.warning {
  background-color: #facc15;
}
.progress.unstable {
  /* background-color: #ef4444; */
   background-color: orange;
}

.inner-item-bottom.good,
.inner-item-bottom.good .icon {
  color: #22c55e;
}
.inner-item-bottom.warning,
.inner-item-bottom.warning .icon {
  color: #facc15;
}
.inner-item-bottom.unstable,
.inner-item-bottom.unstable .icon {
  /* color: #ef4444; */
  color: orange;
}

.inner-item-bottom.offline,
.inner-item-bottom.offline .icon {
  /* color: #ef4444; */
  color: black;
}

.progress-container p.good {
  color: #22c55e;
}
.progress-container p.warning {
  color: #facc15;
}
.progress-container p.unstable {
  color: orange;
  /* color: #ef4444; */
}

.progress-container p.offline {
  color: grey;
}
.inner-item-bottom.good .icon {
  color: #22c55e;
}
.inner-item-bottom.good {
  color: #22c55e;
}
.items-inner {
  display: flex;
  align-items: center;
  width: auto;
  flex-wrap: nowrap;
  gap: 6px;
}

.inner-item-middle-1 img {
  width: 70px;
  height: 30px;
  object-fit: contain;
  display: block;
}

.inner-item-middle-1-right .icon {
  margin-bottom: 9px;
}

.items-inner > p {
  margin-top: 8px;
}

.items-inner > p {
  margin: 0;
  white-space: nowrap;
}

.md-layout.cards.top-cards {
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 900px) {
  .md-layout.cards.top-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .md-layout.cards.top-cards {
    grid-template-columns: 1fr;
  }
}

.top-cards .title {
  font-size: 28px;
  font-weight: 800;
  color: #111827;
}

.top-cards .md-layout-item.item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.top-cards .md-layout-item.item {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.top-cards .md-layout-item.item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
</style>

<script>
import HeartBeat from './heart-beat.vue';
import getImagePath from '../../utils/DiscoImage.util';
import http from '../../utils/Http.util';

export default {
  components: {
    HeartBeat,
  },
  computed: {
    activeProvidersCount() {
      return this.providers.filter((p) => p.provider_online).length;
    },
    averageSuccess() {
      if (!this.providers.length) return 0;
      const total = this.providers.reduce(
        (sum, p) => sum + p.success_percentage,
        0,
      );
      return Math.round(total / this.providers.length);
    },
    filteredProviders() {
      if (!this.searchQuery) return this.providers;
      const query = this.searchQuery.toUpperCase().trim();
      return this.providers.filter((p) => p.disco_code.toUpperCase().includes(query));
    },
  },
  data() {
    return {
      searchQuery: '',
      providers: [],
      snackBar: {
        show: false,
        message: '',
      },
    };
  },
  async mounted() {
    try {
      const { data } = await http.authReq(
        '/dashboard/providers/reliability-index',
        {},
      );
      this.providers = data.sort((a, b) => {
        if (a.provider_online !== b.provider_online) {
          return Number(b.provider_online) - Number(a.provider_online);
        }
        return b.success_percentage - a.success_percentage;
      });

      this.syncMirrorProviderStatus();
    } catch (error) {
      this.snackBar = {
        show: true,
        message: error.response ? error.response.data.message : error.message,
      };
      console.error('Error:', this.snackBar.message);
    }
  },
  methods: {
    getImagePath,
    getStatusClass(percentage, status) {
      if (!status) return 'offline';
      if (percentage < 50) return 'unstable';
      if (percentage < 85) return 'warning';
      return 'good';
    },
    getStatusLabel(percentage, status) {
      if (!status) return 'Offline';
      if (percentage < 50) return ' -- ';
      if (percentage < 85) return 'Unstable';
      return 'Excellent';
    },

    getStatusIcon(percentage, status) {
      if (!status) return 'signal_wifi_off';
      if (percentage < 50) return 'dangerous';
      if (percentage < 85) return 'warning';
      return 'check_circle_outline';
    },

    syncMirrorProviderStatus() {
      const providerMap = this.providers.reduce((map, p) => {
        map[p.disco_code] = p;
        return map;
      }, {});

      // Mirror mapping: mirror → main
      const mirrorMapping = {
        ABAPOWER: 'APLE',
      };

      Object.keys(mirrorMapping).forEach((mirror) => {
        const main = mirrorMapping[mirror];
        if (providerMap[main] && providerMap[main].provider_online !== undefined) {
          const mirrorProvider = providerMap[mirror];
          if (mirrorProvider) {
            mirrorProvider.provider_online = providerMap[main].provider_online;
          }
        }
      });
    },
  },
};
</script>
